import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 bg-white" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-4" data-id="element-52">
            Contact Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary" data-id="element-53">
            Get In Touch
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-54">
          {/* Contact Info */}
          <div className="space-y-8" data-id="element-55">
            <div className="flex items-start gap-4" data-id="element-56">
              <div className="bg-accent p-4 rounded-full" data-id="element-57">
                <MapPinIcon className="w-6 h-6 text-primary" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-60">
                  Headquarters
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-61">
                  123 Towing Blvd
                  <br data-id="element-62" />
                  Alexandria, VA 22314
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-63">
              <div className="bg-accent p-4 rounded-full" data-id="element-64">
                <PhoneIcon className="w-6 h-6 text-primary" data-id="element-65" />
              </div>
              <div data-id="element-66">
                <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-67">
                  Dispatch Center
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-68">
                  718.210.3110
                  <br data-id="element-69" />
                  <span className="text-sm text-gray-500" data-id="element-70">Available 24/7</span>
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-71">
              <div className="bg-accent p-4 rounded-full" data-id="element-72">
                <MailIcon className="w-6 h-6 text-primary" data-id="element-73" />
              </div>
              <div data-id="element-74">
                <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-75">Email</h3>
                <p className="text-gray-600 text-lg" data-id="element-76">
                  support@uzomatowing.com
                  <br data-id="element-77" />
                  <span className="text-sm text-gray-500" data-id="element-78">
                    We reply within 24 hours
                  </span>
                </p>
              </div>
            </div>
          </div>
          {/* Contact Form */}
          <div className="bg-accent rounded-[10px] p-8 shadow-sm" data-id="element-79">
            <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-80">
              <div data-id="element-81">
                <label className="block text-sm font-bold text-secondary mb-1" data-id="element-82">
                  Name
                </label>
                <input type="text" className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="Your Name" data-id="element-83" />
              </div>
              <div data-id="element-84">
                <label className="block text-sm font-bold text-secondary mb-1" data-id="element-85">
                  Email
                </label>
                <input type="email" className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="you@example.com" data-id="element-86" />
              </div>
              <div data-id="element-87">
                <label className="block text-sm font-bold text-secondary mb-1" data-id="element-88">
                  Message
                </label>
                <textarea rows={4} className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="How can we help?" data-id="element-89"></textarea>
              </div>
              <button className="w-full bg-secondary hover:bg-blue-900 text-white font-bold py-4 rounded-[10px] transition-colors" data-id="element-90">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}